import * as Sentry from '@sentry/capacitor';
import { PAYMASH_PROFILE } from '@profile';
import { breadcrumbsIntegration, browserTracingIntegration, browserProfilingIntegration, init } from '@sentry/angular';

export const initSentry = () => {
  Sentry.init(
    {
      dsn: PAYMASH_PROFILE.sentryUrl,
      environment: PAYMASH_PROFILE.sentryEnvironment,
      integrations: [
        breadcrumbsIntegration({
          console: false,
          xhr: false,
        }),
        browserTracingIntegration({
          // tracePropagationTargets: ['localhost', /\.mypaymash\.com/],
          instrumentNavigation: true,
        }) as any,
        browserProfilingIntegration(),
      ],
      tracesSampleRate: 1.0,
      profilesSampleRate: 1.0,
    },
    init
  );
};
